import { lazy } from 'react';

const TableListReportRoutes = [
    {
        path: '/reports/table_list',
        component: lazy(() => import('../../pages/Reports/TableLIst')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },
    {
        path: '/reports/table_list/area_of_law_reports',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/AreaOfLawReports'),
        ),
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },
    {
        path: '/reports/table_list/legal_issues_reports',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LegalIssuesReports'),
        ),
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },
    {
        path: '/reports/table_list/language_reports',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LanguageReports'),
        ),
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },
    {
        path: '/reports/table_list/location_reports',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LocationReports'),
        ),
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },
    {
        path: '/reports/table_list/otherBar_reports',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/OtherbarReports'),
        ),
        meta: {
            action: 'read',
            resource: 'table_list_reports',
        },
    },

    /*  APB */

    {
        path: '/reports/table_list/area_of_law_reports_apb',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/AreaOfLawReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/table_list/legal_issues_reports_apb',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LegalIssuesReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/table_list/language_reports_apb',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LanguageReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/table_list/location_reports_apb',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/LocationReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/table_list/otherBar_reports_apb',
        component: lazy(() =>
            import('../../pages/Reports/TableLIst/OtherbarReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
];

export default TableListReportRoutes;
